/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import { dayjs } from '@2wunder/klarx-tool'
import { GenericObject, RecordType } from 'app/constants/GlobalTypes'
import { RecordTypeEnum } from 'app/queries'
import _ from 'lodash'
import { useMemo } from 'react'

export const isoFormat = 'YYYY-MM-DD'

export const applyNormalizer = <T>(data: T, normalizer: (data: any) => any) => {
  if (data) {
    return normalizer ? normalizer(normalizeKeys(data)) : normalizeKeys(data)
  }
  return data
}

export const applyPaginatedNormalizer = ({
  normalizer,
  data,
  recordType
}: {
  normalizer: (val: any) => any
  data: any
  recordType: RecordTypeEnum
}) => {
  const plurified: any = RecordType.plurify()[recordType as keyof typeof RecordType]

  if (data) {
    return {
      ...data,
      [`${plurified}`]: {
        ...data[plurified],
        nodes: data[plurified].nodes.map(normalizer)
      }
    }
  }
}

export const useNormalizer = <T>(data: T, normalizer: (data: any) => T) => {
  const normalizedData = useMemo(() => applyNormalizer(data, normalizer), [data])
  return { normalizedData }
}

export function normalizeKeys(obj: GenericObject<any>) {
  let x: any = {}

  _.forOwn(obj, function (v, k) {
    if (_.isArray(v)) {
      v = [
        ...v.filter((val) => _.isPlainObject(val)).map((val) => normalizeKeys(val)),
        ...v.filter((val) => !_.isPlainObject(val))
      ]
    } else if (_.isPlainObject(v)) {
      v = normalizeKeys(v)
    }
    x[_.snakeCase(k)] = v
    x[k] = v
  })

  return x
}

export const convertIsoToString = (date: string | null, format?: string) => {
  if (!date) return date

  return format ? dayjs(date).format(format) : dayjs(date).toLocaleDate()
}

export const convertStringToIso = (dateString: string | null) => {
  if (!dateString) return dateString

  return dayjs(dateString).parseLocaleDate().format(isoFormat)
}
